import { useAppStore } from "@hooks/useAppStore";
import { LeaderboardApplet } from "@memorang/ui/components/Leaderboard/LeaderboardApplet";
import type { LeaderboardFilterValue } from "@memorang/ui/components/Leaderboard/types";
import { router } from "expo-router";
import { useState } from "react";
/* -----------------Helpers & Hooks--------------- */
import { useLeaderboard } from "../hooks/useLeaderboard";

const LeaderboardContainer = () => {
	const leaderboardsConfig = useAppStore((state) => state.app.leaderboards);

	const [filter, setFilter] = useState<LeaderboardFilterValue>(() => ({
		timePeriod: leaderboardsConfig.timePeriods[0] ?? "all_time",
		scope: leaderboardsConfig.scopes[0] ?? "global",
	}));

	const {
		leaderboardItems,
		userLeaderboardItem,
		isLoading,
		isError,
		error,
		refetch,
	} = useLeaderboard({ timePeriod: filter.timePeriod });

	return (
		<LeaderboardApplet
			items={leaderboardItems}
			currentUserItem={userLeaderboardItem}
			timePeriod={filter.timePeriod}
			scope={filter.scope}
			config={leaderboardsConfig}
			onFilterChange={(value) => setFilter(value)}
			isLoading={isLoading}
			error={
				isError
					? {
							description: error?.message,
						}
					: undefined
			}
			onStart={() => {
				router.push("/home");
			}}
			onRefresh={refetch}
		/>
	);
};

export default LeaderboardContainer;
